import { Field, Form, Formik } from "formik";
import { checkoutvalidation } from "../../../../Validation/Checkout";
import { gettoken } from "../../../../Localstorage/Store";
import { useSelector } from "react-redux";
import { getCode } from "country-list";
import { useRef, useState } from "react";
import axios from "axios";
import { usePostCreateAddressMutation } from "../../../../store/api/addressapi";

const CreateAddress = ({ address,onAddressChange }) => {
  const tokenvalue = gettoken();
  const closeaddressbtn = useRef(null);
  const [addressstatus, setaddressstatus] = useState(false);
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [cityna, setcityna] = useState("");
  const [NewAddress] = usePostCreateAddressMutation();


  const handleClick = () => {
    const buttonNode = closeaddressbtn.current;
    if (buttonNode) {
      buttonNode.click();
    }
  };
  const createaddress = async (values, setFieldError) => {
    try {
 
      const formdata = new FormData();
      formdata.append("first_name", values.first_name);
      formdata.append("last_name", values.last_name);
      formdata.append("phone_number", `+91${values.mobile}`);
      formdata.append("line1", values.address1);
      formdata.append("line2", values.address2);
      formdata.append("country", getCode(values.country));
      formdata.append("state", values.state);
      formdata.append("email", values.email);
      formdata.append("line4", values.city);
      formdata.append("address_type", values.address_type);
      formdata.append("postcode", values.pincode);
      if (tokenvalue.msg == "Voucher login") {
        formdata.append("user", tokenvalue.user_id);
      } else {
        formdata.append("user", tokenvalue.id);
      }
  
      const response = await NewAddress(formdata);
      if (response.data?.id) {
        setaddressstatus(true);
        setTimeout(() => {
          onAddressChange(response.data?.id);
          setaddressstatus(false);
          handleClick();
        }, 1500);

      } else {
      }
    } catch (error) {
      console.log("create address error ",error);
      setFieldError("mobile", error?.response?.data?.phone_number[0]);
    }
  };

  const fetchstateandcity = async (value, setFieldError, setFieldValue) => {
    if (value.length == 6) {
      try {
        let url = `${process.env.REACT_APP_API_URL}my_api/get-postcode-information/?postal_code=${value}`;
        const response = await axios.get(url);
        if (response.data.city == "NA") {
          setFieldValue("city", "");
          setcityna("NA");
          setFieldError("city", "Please Enter Your City");
        } else {
          setFieldValue("city", response.data.city);
          setcityna("");
        }
        setFieldValue("state", response.data.state);
        const countrydata = address.country.filter(
          (item2) => item2.printable_name == response.data.country.trim()
        );
        setFieldValue("country", countrydata[0].printable_name);
        setFieldValue("countryurl", countrydata[0].url);
      } catch (error) {
        setFieldError("pincode", error.response.data.message);
      }
    } else {
      setFieldValue("city", "");
      setFieldValue("state", "");
      setFieldValue("country", "");
      setFieldValue("countryurl", "");
    }
  };

  return (
    <>

      <button
      type="button"
        style={{
          border: "none",
          outline: "none",
          backgroundColor: "#fff",
          padding: "3px 3px",
          color: `#${bgColor}`,
          width: "fit-content",
          fontWeight: 600,
        }}
        data-bs-toggle="modal"
        data-bs-target="#addaddressmodel"
      >
        +Add
      </button>
















      <div
        class="modal fade"
        id="addaddressmodel"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog " style={{ maxWidth: "770px", marginTop: "68x`x`x`px" }}>
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                Add Address
              </h1>
              <button
                type="button"
                ref={closeaddressbtn}
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <Formik
                initialValues={{
                  first_name: "",
                  last_name: "",
                  email: "",
                  mobile: "",
                  address1: "",
                  address2: "",
                  country: "",
                  countryurl: "",
                  state: "",
                  city: "",
                  pincode: "",
                  address_type: "HOME",
                }}
                validationSchema={checkoutvalidation}
                onSubmit={(values, { setFieldError }) => {
                  createaddress(values, setFieldError);
                }}
              >
                {({
                  values,
                  errors,
                  handleSubmit,
                  touched,
                  handleChange,
                  setFieldValue,
                  setFieldError,
                }) => (
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="row check-out ">
                      <div className="form-group col-md-12 col-sm-12 col-xs-12 mb-0">
                        <label className=" acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Address Type
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <div className="d-flex" style={{ gap: "10px" }}>
                          <div>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              <input
                                type="radio"
                                name="address_type"
                                value="HOME"
                                onChange={handleChange}
                                checked={values.address_type == "HOME"}
                              />
                              HOME
                            </label>
                          </div>
                          <div>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              <input
                                type="radio"
                                name="address_type"
                                value="OFFICE"
                                onChange={handleChange}
                                checked={values.address_type == "OFFICE"}
                              />
                              OFFICE
                            </label>
                          </div>
                          <div>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              <input
                                type="radio"
                                name="address_type"
                                value="OTHER"
                                onChange={handleChange}
                                checked={values.address_type == "OTHER"}
                              />
                              OTHER
                            </label>
                          </div>
                        </div>
                        <div className="error">
                          {errors.address_type && touched.address_type ? (
                            <p className="text-start" style={{ color: "red" }}>
                              {errors.address_type}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle m-0" style={{ textAlign: "start", width: "100%" }}>
                          First Name{" "}
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>

                        <Field
                          type="text"
                          name="first_name"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your First Name"
                          value={values?.first_name}
                        />
                        <div className="error">
                          {errors.first_name && touched.first_name ? (
                            <p className="text-start" style={{ color: "red" }}>
                              {errors.first_name}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle m-0" style={{ textAlign: "start", width: "100%" }}>
                          Last Name
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="last_name"
                          type="text"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Last Name"
                          value={values?.last_name}
                        />
                        <div className="error">
                          {errors.last_name && touched.last_name ? (
                            <p className="text-start" style={{ color: "red" }}>
                              {errors.last_name}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Phone
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="mobile"
                          type="tel"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your Mobile. No"
                          value={values?.mobile}
                          onChange={(e) => {
                            setFieldValue(
                              "mobile",
                              e.target.value.replace(/\D/g, "")
                            );
                          }}
                        />
                        <div className="error">
                          {errors.mobile && touched.mobile ? (
                            <p className="text-start" style={{ color: "red" }}>{errors.mobile}</p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Email Address
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          style={{ fontSize: "12px" }}
                          placeholder="Enter Your Email Address"
                          value={values?.email}
                        />
                        <div className="error">
                          {errors.email && touched.email ? (
                            <p className="text-start" style={{ color: "red" }}>{errors.email}</p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }} >
                          Address 1
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="address1"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="House number and street name"
                          value={values.address1}
                        />
                        <div className="error">
                          {errors.address1 && touched.address1 ? (
                            <p className="text-start" style={{ color: "red" }}>
                              {errors.address1}
                            </p>
                          ) : null}
                        </div>

                      </div>
                      <div className="form-group col-md-12 col-sm-12 col-xs-12">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }} >
                          Address 2
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="address2"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control mt-2"
                          placeholder="Apartment, suite, unit etc."
                          value={values.address2}
                        />
                        <div className="error">
                          {errors.address2 && touched.address2 ? (
                            <p className="text-start" style={{ color: "red" }}>
                              {errors.address2}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12">
                        <label className=" acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }} >
                          Postal Code
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="pincode"
                          type="tel"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your Pincode"
                          value={values.pincode}
                          minLength={6}
                          maxLength={6}
                          onChange={(e) => {
                            setFieldValue(
                              "pincode",
                              e.target.value.replace(/[^0-9\ ]/gi, "")
                            );
                            fetchstateandcity(
                              e.target.value.replace(/[^0-9\ ]/gi, ""),
                              setFieldError,
                              setFieldValue
                            );
                          }}
                        />
                        <div className="error">
                          {errors.pincode && touched.pincode ? (
                            <p className="text-start" style={{ color: "red" }}>{errors.pincode}</p>
                          ) : null}
                        </div>
                      </div>

                      {values.state !== "" &&
                        values.state !== null &&
                        cityna == "NA" ? (
                        <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                          <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }} >
                            City
                            <span
                              style={{ color: "red", fontSize: "13px" }}
                            >
                              {" "}
                              *
                            </span>
                          </label>
                          <Field
                            name="city"
                            type="text"
                            style={{ fontSize: "12px" }}
                            className="form-control"
                            placeholder="Enter Your City"
                            value={values.city}
                          />
                          <div className="error">
                            {errors.city && touched.city ? (
                              <p className="text-start" style={{ color: "red" }}>{errors.city}</p>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                          <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }} >
                            City
                            <span
                              style={{ color: "red", fontSize: "13px" }}
                            >
                              {" "}
                              *
                            </span>
                          </label>
                          <Field
                            name="city"
                            type="text"
                            style={{ fontSize: "12px" }}
                            className="form-control"
                            placeholder="Enter Your City"
                            readOnly
                            value={values.city}
                          />
                          <div className="error">
                            {errors.city && touched.city ? (
                              <p className="text-start" style={{ color: "red" }}>{errors.city}</p>
                            ) : null}
                          </div>
                        </div>
                      )}


                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }} >
                          State
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="state"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Enter Your State"
                          readOnly
                          value={values.state}
                        />
                        <div className="error">
                          {errors.state && touched.state ? (
                            <p className="text-start" style={{ color: "red" }}>{errors.state}</p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-xl-6 col-md-12 col-sm-12 col-xs-12 cht">
                        <label className="acounttitle field-label m-0" style={{ textAlign: "start", width: "100%" }}>
                          Country
                          <span style={{ color: "red", fontSize: "13px" }}>
                            {" "}
                            *
                          </span>
                        </label>
                        <Field
                          name="country"
                          type="text"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Country"
                          readOnly
                          value={values.country}
                        />
                        <Field
                          name="countryurl"
                          type="hidden"
                          style={{ fontSize: "12px" }}
                          className="form-control"
                          placeholder="Country"
                          readOnly
                          value={values.countryurl}
                        />
                        <div className="error">
                          {errors.country && touched.country ? (
                            <p className="text-start" style={{ color: "red" }}>{errors.country}</p>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                        <div className="payment-box">
                          <div
                            className="text-left"
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              gap: "4px",
                            }}
                          >
                            <button
                              type="button"
                              style={{
                                fontSize: "12px",
                                background: "#bdbfc0",
                                color: "#000",
                              }}
                              className="btn-normal btn"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            //   ref={buttonRef}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              style={{ fontSize: "12px", background: `#${bgColor}` }}
                              className="btn-normal btn"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="form-group col-md-12 col-sm-12 col-xs-12 cht">
                        <div
                          class="alert alert-success"
                          role="alert"
                          style={{
                            display:
                              addressstatus == true ? "block" : "none",
                          }}
                        >
                          Address Created Successfully
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>

          </div>
        </div>
      </div>

    </>
  )
}

export default CreateAddress